import React from 'react';

import {CloseButton} from 'shells/button/close-button/close-button';
import {Card} from 'shells/card/card';
import {GridList} from 'shells/grid-list/grid-list';
import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';
import {Body} from 'shells/typography/body';

import type {FormattedOption} from '../helpers';

import styles from '../security-page.module.css';

type Props = {
    formattedNonExemptUsers: FormattedOption[];
    formattedExemptFromSsoUsers: FormattedOption[];
    handleAddExemptUser: (selectedUser: FormattedOption) => void;
    handleRemoveExemptUser: (selectedUser: FormattedOption) => void;
    exemptUsersError: string | null | undefined;
};

export function SsoExemptUsers(props: Props) {
    return (
        <div className='flex flex-dir-col gap-8'>
            <Body size='small' isBold={true}>
                Select your exempted users
            </Body>
            <Body size='small' color='medium'>
                Users who are not required to log in via SSO can be designated as exempt users. You
                can edit your users after configuration as well.
            </Body>
            <div className={styles['sso-input-container']}>
                <SelectPickerGeneric
                    options={props.formattedNonExemptUsers || []}
                    // @ts-expect-error
                    onChange={(selectedUser) => {
                        props.handleAddExemptUser(selectedUser);
                    }}
                    value={null}
                    placeholder='Select a user'
                />
            </div>
            <GridList gridGap={8} itemWidth={160}>
                {props.formattedExemptFromSsoUsers.length > 0 ? (
                    props.formattedExemptFromSsoUsers.map((user) => {
                        return (
                            <div key={user.value} className={styles['sso-exempt-user-card']}>
                                <Card hasBorder={true}>
                                    <div className='flex pad-8 justify-sb align-center'>
                                        <div className='truncate'>
                                            <Body size='small' color='medium'>
                                                {user.label}
                                            </Body>
                                        </div>
                                        <div className={styles['sso-icon-in-button']}>
                                            <CloseButton
                                                onClick={() => props.handleRemoveExemptUser(user)}
                                                tooltip={`Remove ${user.label}'s SSO exemption`}
                                            />
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        );
                    })
                ) : (
                    <></>
                )}
            </GridList>
            {props.exemptUsersError && (
                <Body size='small' color='error'>
                    {props.exemptUsersError}
                </Body>
            )}
        </div>
    );
}
